import React from 'react';
import './HeadTitle.css';

function HeadTitle() {
  return (
    <div id="head-title">
      <h1>TV Program 1968</h1>
    </div>
  );
}

export default HeadTitle;



// WEBPACK FOOTER //
// ./src/components/App/Program/Head/HeadTitle/HeadTitle.js